/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Member_Transfer_DescriptionInputs */



/**
* | output |
* | --- |
* | "Choose who takes over the shared spaces and projects {email} created or administers." |
*
* @param {Member_Transfer_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_transfer_description = /** @type {((inputs: Member_Transfer_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Transfer_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Wählen Sie, wer die geteilten Spaces und Projekte übernimmt, die ${i?.email} erstellt hat oder verwaltet.`)
	return /** @type {LocalizedString} */ (`Choose who takes over the shared spaces and projects ${i?.email} created or administers.`)
});